import axios from "axios";

export interface IActivities {
  profileType: string;
  profileId: string;
  page: number;
  pageSize: number;
}

export interface INote {
  profileType: string;
  profileId: number;
  note: string;
}

export const fetchActivities = ({
  profileType,
  profileId,
  page,
  pageSize,
}: IActivities) => {
  return axios.get(`/api/timeline/${profileType}/${profileId}/list`, {
    params: {
      page,
      pageSize,
    },
  });
};

export const createNote = ({ profileType, profileId, note }: INote) => {
  return axios.post(`/api/timeline/${profileType}/${profileId}/notes`, {
    note: note,
  });
};
